/**
 * zel-finance.doseo
 * 12.09.2017 14:31
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2017 delphinpro
 * @license     licensed under the MIT license
 */

import $ from 'jquery';


export default function(options) {
  options = options || {};
  if (options.toString() !== '[object Object]') {
    options = {};
  }

  options = {
    button        : 'hamburger',
    stateOpenClass: 'hamburger_state_cross',
    stateOpenFlag : 'f-hamburger-open',
    ...options
  };

  let $hamburger = $(`.${options.button}`);

  $hamburger.on('click', function() {
    $(document.documentElement).toggleClass(options.stateOpenFlag);
    $hamburger.toggleClass(options.stateOpenClass);
  });
}



// WEBPACK FOOTER //
// ./source/js/components/hamburger.js